export const getGothamUiRedirect = ({hash, hostname, pathname, search}: Pick<Location, 'hash' | 'hostname' | 'pathname' | 'search'>): string | undefined => {
  const suffix = `${search}${hash}`;
  if(hostname === 'gothamjs.nitrogenx.co') return `https://gothamui.nitrogenx.co${pathname}${suffix}`;
  const path = pathname.replace(/^\/(projects\/)?gothamjs(?=\/|$)/u, '/$1gothamui');
  return path === pathname ? undefined : `${path}${suffix}`;
};
